<template>
  <div>
    <navbar />
    <v-main>
      <v-container :fluid="isFluidPage" :class="{ 'page-fluid': isFluidPage }">
        <!-- <div class="p-5"> -->
        <router-view></router-view>
        <!-- </div> -->
      </v-container>
    </v-main>
  </div>
</template>

<script>
import navbar from "./navbar.vue";
export default {
  components: { navbar },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      { icon: "contacts", text: "Contacts" },
      { icon: "history", text: "Frequently contacted" },
      { icon: "content_copy", text: "Duplicates" },
      {
        icon: "keyboard_arrow_up",
        "icon-alt": "keyboard_arrow_down",
        text: "Labels",
        model: true,
        children: [{ icon: "add", text: "Create label" }],
      },
      {
        icon: "keyboard_arrow_up",
        "icon-alt": "keyboard_arrow_down",
        text: "More",
        model: false,
        children: [
          { text: "Import" },
          { text: "Export" },
          { text: "Print" },
          { text: "Undo changes" },
          { text: "Other contacts" },
        ],
      },
      { icon: "settings", text: "Settings" },
      { icon: "chat_bubble", text: "Send feedback" },
      { icon: "help", text: "Help" },
      { icon: "phonelink", text: "App downloads" },
      { icon: "keyboard", text: "Go to the old version" },
    ],
  }),
  props: {
    source: String,
  },
  computed: {
    isFluidPage() {
      return this.$route.matched.some(
        (record) => record.meta && record.meta.fluid,
      );
    },
  },
};
</script>

<style scoped>
/* Full-bleed pages (e.g. the ticket board) must not be capped by the
   Vuetify container breakpoints. */
.page-fluid {
  max-width: 100% !important;
  padding-left: 32px;
  padding-right: 32px;
}

@media (max-width: 600px) {
  .page-fluid {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
